export default function EventIcon({
  width = 16,
  height = 10,
  color = "#8E8C8F",
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6666 4.33334C11.7733 4.33334 12.66 3.44001 12.66 2.33334C12.66 1.22668 11.7733 0.333344 10.6666 0.333344C9.55996 0.333344 8.66663 1.22668 8.66663 2.33334C8.66663 3.44001 9.55996 4.33334 10.6666 4.33334ZM5.33329 4.33334C6.43996 4.33334 7.32663 3.44001 7.32663 2.33334C7.32663 1.22668 6.43996 0.333344 5.33329 0.333344C4.22663 0.333344 3.33329 1.22668 3.33329 2.33334C3.33329 3.44001 4.22663 4.33334 5.33329 4.33334ZM5.33329 5.66668C3.77996 5.66668 0.666626 6.44668 0.666626 8.00001V9.00001C0.666626 9.36668 0.966626 9.66668 1.33329 9.66668H9.33329C9.69996 9.66668 9.99996 9.36668 9.99996 9.00001V8.00001C9.99996 6.44668 6.88663 5.66668 5.33329 5.66668ZM10.6666 5.66668C10.4733 5.66668 10.2533 5.68001 10.02 5.70001C10.0333 5.70668 10.04 5.72001 10.0466 5.72668C10.8066 6.28001 11.3333 7.02001 11.3333 8.00001V9.00001C11.3333 9.23334 11.2866 9.46001 11.2133 9.66668H14.6666C15.0333 9.66668 15.3333 9.36668 15.3333 9.00001V8.00001C15.3333 6.44668 12.22 5.66668 10.6666 5.66668Z"
        fill={color}
      />
    </svg>
  );
}
